import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody, Label, Input, Button, Spinner, CardImg } from 'reactstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FaTimes } from 'react-icons/fa';
import { toast } from "react-toastify";
import ApiClient from "../../api-client";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from 'react-router-dom';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { RiAddCircleLine, RiDeleteBinLine } from 'react-icons/ri';

const UpdateArticle = () => {
  const [loader, setLoader] = useState(false);
  const location = useLocation();

  const dispatch = useDispatch();
  const [articleName, setArticleName] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [videoLinks, setVideoLinks] = useState([]);
// Update the state to store selected image files
  const [selectedImages, setSelectedImages] = useState([]);
  const [articlePrevImage, setArticlePrevImage] = useState([]);
  const [articleImages, setArticleImages] = useState([]);
  const [removedImages, setRemovedImages] = useState([]);
  const [fileInputKey, setFileInputKey] = useState(Date.now());

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  useEffect(() => {
    getArticleDetailsById();
  }, [id]);

  const getArticleDetailsById = async () => {
    if (id) {
      try {
        const getData = await ApiClient.get(
          `/admin/get-article-by-id/${id}`,
          "",
          true,
          dispatch
        );

        setArticleName(getData.body.articleName);
        setTitle(getData.body.title);
        setDescription(getData?.body?.description);
        setVideoLinks(getData?.body?.videoLink);
        // setVideoLinks(Array.isArray(getData?.body?.videoLink) ? getData.body.videoLink : []);

        setArticleImages(getData?.body.articleImages);
        setArticlePrevImage(getData?.body?.articleImagesThumbnail);
      } catch (error) {
        console.log("error: " + error);
      }
    }
  };

  const handleRemoveImage = (thumbnailKey) => {
    // Find the index of the thumbnail in the articlePrevImage array
    const index = articlePrevImage.findIndex(image => image.key === thumbnailKey);
  
    // If the index is found
    if (index !== -1) {
      // Get the full-size image key using the same index
      const fullSizeImageKey = articleImages[index].key;
  
      // Add both keys to the removedImages array
      setRemovedImages([...removedImages, thumbnailKey, fullSizeImageKey]);
  
      // Remove the images from their respective arrays using the index
      const updatedArticlePrevImage = articlePrevImage.filter((_, i) => i !== index);
      const updatedArticleImages = articleImages.filter((_, i) => i !== index);
    
  
      // Update the state with the new arrays
      setArticlePrevImage(updatedArticlePrevImage);
      setArticleImages(updatedArticleImages);
    } else {
      console.error('Thumbnail image not found for key:', thumbnailKey);
    }
  };
  

  const validate = () => {
    const errors = {};
    if (!articleName) {
      errors.articleName = "Article name is required";
    }
    if (!title) {
      errors.title = "Title is required";
    }
    if (!description) {
      errors.description = "Description is required";
    }
    if ((!selectedImages || selectedImages.length === 0) && (!articlePrevImage || articlePrevImage.length === 0)) {
      errors.articleImages = "Article image is required";
    } else {
      // Check the size of each selected image
      for (let image of selectedImages) {
        if (image.size / 1000000 > 5) { // size is in bytes, so converting to MB
          errors.articleImages = "File size should not be greater than 5MB";
          break;
        }
      }
    }
    return errors;
  };
  

  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      setLoader(true);
      const formData = new FormData();
      formData.append("articleName", articleName);
      formData.append("title", title);
      formData.append("description", description);
      if(videoLinks.length === 0){
        formData.append("videoLink",[]);
      }else {
        for (const link of videoLinks) {
          formData.append('videoLink', link);
        }
      }
      
      selectedImages.forEach(image => formData.append("articleImages", image));

      try {
        let saveData;
        if (id) {
          formData.append("id", id);
          if (removedImages.length > 0) {
            removedImages.forEach(image => formData.append("removedImages", image));
          } else {
            formData.append("removedImages",'');
          }
          saveData = await ApiClient._putFormData(
            `admin/update-article`,
            formData,
            true,
            dispatch
          );
        }

        if (saveData.status === true) {
          toast.success(saveData.message, { autoClose: 3000 });
          navigate('')
          setArticleName('');
          setTitle('');
          setDescription('');
          setVideoLinks([]);
          setArticleImages([]);
          setArticlePrevImage([]);
          setRemovedImages([]);
          setSelectedImages([])
          navigate('/admin/article/list')
        } else {
          toast.error(saveData.message, { autoClose: 3000 });
          setLoader(false);
        }
        setLoader(false);
      } catch (error) {
        toast.error(error.message, { autoClose: 3000 });
        setLoader(false);
      }

    }
  };
  const handleRemoveVideoLink = (index) => {
    const newVideoLinks = videoLinks.filter((_, i) => i !== index);
    setVideoLinks(newVideoLinks);
  };

  const handleAddVideoLink = () => {
    setVideoLinks([...videoLinks, '']);
  };

  const handleVideoLinkChange = (index, value) => {
    const newVideoLinks = videoLinks.map((link, i) => (i === index ? value : link));
    setVideoLinks(newVideoLinks);
  };


const handleImageSelection = (e) => {
  const files = Array.from(e.target.files);
  setSelectedImages([...selectedImages, ...files]);
};


const removeImage = (index) => {
  const newImages = selectedImages.filter((_, i) => i !== index);
  setSelectedImages(newImages);
  if (newImages.length === 0) {
    setFileInputKey(Date.now());
  }
};


  return (
    <div className="content">
      <Container>
      <Button
          color="primary"
          className="ml-10 common-button"
          onClick={() => navigate("/admin/article/list")}
        >
          <IoMdArrowRoundBack /> Back
        </Button>
        <Card>
          <CardBody>
            <form onSubmit={handleSubmit}>
              <Row className="mt-3">
                <Col md="6">
                  <Label for="articleName" className="card-heading">Article Name:</Label>
                  <Input
                    type="text"
                    id="articleName"
                    name="articleName"
                    value={articleName}
                    onChange={(e) => setArticleName(e.target.value)}
                  />
                  {errors.articleName && (
                    <div className="error-message ">{errors.articleName}</div>
                  )}
                </Col>
                <Col md="6">
                  <Label for="title" className="card-heading">Title:</Label>
                  <Input
                    type="text"
                    id="title"
                    name="title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                  {errors.title && (
                    <div className="error-message ">{errors.title}</div>
                  )}
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md="12">
                  <Label for="description" className="card-heading">Description:</Label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={description}
                    onChange={(event, editor) => setDescription(editor.getData())}
                    config={{
                      removePlugins: ['ImageUpload', 'MediaEmbed', 'EasyImage', 'ImageToolbar', 'ImageCaption', 'ImageStyle', 'ImageResize', 'ImageInsert'],
                      toolbar: [
                        'heading', '|',
                        'bold', 'italic', 'link', '|',
                        'bulletedList', 'numberedList', '|',
                        'blockQuote', 'insertTable', '|',
                        'undo', 'redo'
                      ]
                    }}
                  />
                  {errors.description && (
                    <div className="error-message ">{errors.description}</div>)}
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md="6">
                  <Label for="videoLink" className="card-heading">Video Link:</Label>
              {videoLinks.map((link, index) => (
              <Row key={index} className="mb-2 align-items-center">
                <Col md={10}>
                  <Input
                    type="text"
                    value={link}
                    onChange={(e) => handleVideoLinkChange(index, e.target.value)}
                  />
                </Col>
                <Col md={2} className="text-right">
                  <Button color="link" onClick={() => handleRemoveVideoLink(index)}>
                    <RiDeleteBinLine size={24} />
                  </Button>
                </Col>
              </Row>
            ))}
               <Button color="link" onClick={handleAddVideoLink}>
              <RiAddCircleLine size={24} />
            </Button>
                </Col>
              </Row>
              <Row className="mt-3">
              <Col md="12">
                <Label for="articleImage" className="card-heading">Article Images:</Label>
                <Input
                  type="file"
                  id="articleImage"
                  key={fileInputKey} // Add the key prop to force re-render
                  name="articleImage"
                  accept=".jpg,.jpeg,.png"
                  onChange={handleImageSelection}  
                  multiple
                />
                {errors.articleImages && (
                  <div className="error-message">
                    {errors.articleImages}
                  </div>
                )}
                <div className="d-flex flex-wrap">
                  {articlePrevImage && articlePrevImage.map((image, index) => (
                    <div key={index} className="img-preview-container position-relative mr-2 mb-2">
                      <CardImg
                        alt="Thumbnail"
                        className="img-preview-small"
                        src={image?.url}
                        top
                      />
                      {/* <FaTimes
                        className="img-remove-icon"
                        onClick={() => handleRemoveImage(image.key)}
                      /> */}
                       <Button color="link" size="sm" className="position-absolute" style={{ top: 0, right: 0 }} onClick={() => handleRemoveImage(image.key)}>
                    <RiDeleteBinLine size={24} />
                  </Button>
                    </div>
                  ))}
                    {selectedImages.map((image, index) => (
                      <div key={index} className="img-preview-container position-relative mr-2 mb-2">
                        <CardImg
                          src={URL.createObjectURL(image)}
                          className="img-preview-small"
                          alt={`preview-${index}`}
                          style={{ width: '100px' }}
                        />
                    <Button color="link" size="sm" className="position-absolute" style={{ top: 0, right: 0 }} onClick={() => removeImage(index)}>
                    <RiDeleteBinLine size={24} />
                  </Button>
                      </div>
                    ))}
                  </div>
              </Col>
            </Row>
              <Button type="submit" color="primary" className="ml-10 mt-4 common-button">
                Submit
                {loader && <Spinner size="sm"className='ml-2' />}
              </Button>
            </form>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default UpdateArticle;
